export const commonStyles = {
  formLabel: {
    fontSize: '12px',
    fontWeight: 400,
    marginBottom: '8px',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      height: '40px',
      fontSize: '14px',
      borderRadius: '6px',
      '& fieldset': {
        borderColor: '#E0E0E0',
      },
    },
  },
  typography: {
    title: {
      fontSize: '16px',
      fontWeight: 400,
      color: 'custom.textBlue',
    },
    description: {
      fontSize: '14px',
      color: 'lightGray.text',
    },
  },
};
